import Table from "../../components/table/Table";
import { useApiClient } from "../../shared/customHooks";
import { PageHeader } from "../../components/header/PageHeader";
import { providerListTable } from "../../shared/tableObjects/provider/providerListTable";

export default function ProviderList() {
  const apiClient = useApiClient("Provider");
  const headerText = [
    {
      class: "p-0 m-0 flex align-center",
      value: "List of KIS Providers",
      icon: "list-icon",
    },
  ];
  return (
    <>
      <PageHeader headerText={headerText} hideBreadcrumbs={true} icon={"icon"}></PageHeader>
      <div className="list-table">
        {" "}
        <Table apiClient={apiClient} label={""} columns={providerListTable("providers")} />
      </div>
    </>
  );
}
